module.exports = __webpack_public_path__ + "static/media/jakarta-pusat.aaa6176b.svg";